<template>
  <div class="login">
    <div class="switch-login-type">
      <div class="switch-btn log-in active">
        {{ $t('header.white.loginButton') }}
      </div>
      <a
        :href="createProfileLink"
        class="switch-btn sign-up"
      >
        {{ $t('header.white.singUpButton') }}
      </a>
    </div>

    <h5>{{ $t('header.white.login.loginTitle') }}</h5>

    <login-form
      @success="success"
      @openForgotPassword="openForgotPassword"
      @fail="showErrorModal"
    />
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import LoginForm from 'components/LoginForm/LoginForm'
  import PinsLoginForm from 'components/LoginForm/PinsLoginForm'
  import ScrollUtils from 'utils/scrollUtils'
  import FormMixin from 'components/FormMixin'
  import gtmProfile from 'services/AirBaltic/GTM/Profile'

  export default {
    components: {
      LoginForm
    },
    mixins: [FormMixin],

    computed: {
      ...mapState('main', ['selectedLang', 'createProfileLink']),
      ...mapState('loginForm', ['isLoginPage'])
    },

    methods: {
      showErrorModal(e, loginType = 'email') {
        const page = this.isLoginPage ? 'login_page' : 'bt_pages'
        if (e?.error?.type === 'informal') {
          this.$store.commit('header/closeAllPreHeaderItems')
          this.openFormNotification('fail', e.error)
          gtmProfile.failedLoginAction(loginType, page, this.$t(e.error.content))
          return
        }
        gtmProfile.failedLoginAction(loginType, page, this.$t(e.error))
      },
      openForgotPassword() {
        const ForgotPasswordForm = import(
          /* webpackChunkName: "white-forgot-password-form" */ 'components/LoginForm/White/ForgotPasswordForm.vue'
        )
        ForgotPasswordForm.then((result) => {
          this.$store.commit('main/setModalContent', result.default)
        })

        this.$store.dispatch('main/openModal')
        this.$store.commit('main/setModalCloseFn', this.closeModal)
        this.$store.commit('main/setModalType', 'sidebar')
        this.$store.commit('main/setModalClass', 'modal-white-sidebar')
        this.$store.commit('main/setShowModalHeader', false)
        this.$store.commit('main/setShowModalHeaderWhite', false)
        this.$store.commit('main/setShowModalHeaderWhiteNav', false)
        this.$store.commit('main/setShowCloseIcon', true)
      },

      closeModal() {
        this.$store.dispatch('main/closeModal')
        this.$store.dispatch('loginForm/forgotPassword/resetForm')
      },

      openPinsLoginModal() {
        this.$store.dispatch('main/openModal')
        this.$store.commit('main/setModalContent', PinsLoginForm)
        this.$store.commit('main/setModalCloseFn', this.closeModal)
        this.$store.commit('main/setModalType', 'sidebar')
        this.$store.commit('main/setModalClass', 'modal-white-sidebar')
        this.$store.commit('main/setShowModalHeaderWhiteNav', true)
        this.$store.commit('main/setShowModalHeader', false)
        this.$store.commit('main/setShowCloseIcon', true)
        this.$store.commit('main/setModalProps', { type: 'login' })
        this.$store.commit('header/closeAllPreHeaderItems')
      },

      success(loginType = 'email') {
        const page = this.isLoginPage ? 'login_page' : 'bt_pages'
        this.$store.commit('header/closeAllPreHeaderItems')
        ScrollUtils.enableScroll()
        gtmProfile.loginSuccessAction(loginType, page)
      }
    }
  }
</script>

<style
  lang="scss"
  rel="stylesheet/scss"
  scoped
>
  @import '~assets/styles/common.scss';

  .switch-login-type {
    @include clearfix();
  }

  .switch-btn {
    float: left;
    padding: 0 10px;
    width: 50%;
    height: 48px;
    border: 1px solid $formInputBorder;
    @include text-overflow();
    font-weight: 500;
    line-height: 48px;
    text-align: center;
    color: $blue-medium;
    cursor: pointer;

    @include outline-focus;

    &.active,
    &:hover {
      border-color: $blue-medium;
    }

    &.active {
      background-color: $blue-white;
    }
  }

  .log-in {
    border-radius: 4px 0 0 4px;
  }

  .sign-up {
    border-radius: 0 4px 4px 0;
    border-left: none;
    text-decoration: none;
  }

  h5 {
    margin: 24px 0 18px;
    font-size: em(18);
    font-weight: 500;
  }

  ::v-deep .login-form {
    @include bp-tablet {
      .with-pins {
        margin-bottom: 0;
      }

      .show-password :hover {
        .tooltip {
          display: none;
        }
      }
    }

    @include bp-tablet {
      .form-errors {
        position: inherit;
        padding: 10px 20px;
        font-size: em(12);

        &:before {
          display: none;
        }
      }
    }
  }
</style>
